import {useMemo, useState} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {ChargesColumns} from './columns/_columns'
import {charge} from '../core/_models'
import {ListPagination} from '../components/pagination/ListPagination'
import {KTCardBody} from '../../../../../_metronic/helpers'
import {LoadingListLoading} from '../../../../../utils/loading/loadingListLoading'

const Table = () => {
  const charges = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const [expandedId, setExpandedId] = useState<number | null>(null)

  const data = useMemo(() => charges, [charges])
  const columns = useMemo(() => ChargesColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  const toggleExpanded = (id: number) => setExpandedId((prev) => (prev === id ? null : id))

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive mb-10'>
        <table
          id='kt_table_reportSales'
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              <th className='min-w-50px'></th>
              {headers.map((column: ColumnInstance<charge>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<charge>, i) => {
                prepareRow(row)
                return (
                  <CustomRow
                    row={row}
                    key={`row-${i}-${row.id}`}
                    isOpen={expandedId === row.original.id}
                    onToggle={toggleExpanded}
                  />
                )
              })
            ) : (
              <tr>
                <td colSpan={8}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Nenhum registro encontrado
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ListPagination />
      {isLoading && <LoadingListLoading title='Carregando' />}
    </KTCardBody>
  )
}

export {Table}
